import React, { useState } from 'react';
import './HostingDirectAdmin.css';

const HostingDirectAdmin = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'استارتر',
      price: '۱۲۰',
      unit: 'هزار تومان / ماه',
      disk: '۳ گیگابایت SSD',
      domains: '۳ دامنه addon',
      email: '۳۰ اکانت ایمیل',
      features: ['SSL رایگان', 'پشتیبانی ۲۴/۷', 'مدیریت آسان'],
      popular: false,
    },
    {
      tier: 'پیشرفته',
      price: '۲۵۰',
      unit: 'هزار تومان / ماه',
      disk: '۱۰ گیگابایت SSD',
      domains: 'نامحدود دامنه addon',
      email: 'نامحدود ایمیل',
      features: ['SSL رایگان', 'بکاپ روزانه', 'پشتیبانی ۲۴/۷', 'IP اختصاصی'],
      popular: true,
    },
    {
      tier: 'حرفه‌ای',
      price: '۴۸۰',
      unit: 'هزار تومان / ماه',
      disk: '۳۰ گیگابایت SSD',
      domains: 'نامحدود دامنه addon',
      email: 'نامحدود ایمیل',
      features: ['SSL Wildcard', 'بکاپ روزانه', 'پشتیبانی ۲۴/۷', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '🔧',
      title: 'کنترل پنل DirectAdmin سبک و سریع',
      desc: 'DirectAdmin یک کنترل پنل سبک، سریع و کم‌مصرف است که با منابع کم نیز عملکرد عالی دارد. مناسب برای سرورهایی با منابع محدود و کاربرانی که به دنبال کنترل پنلی ساده و کارآمد هستند.',
    },
    {
      icon: '💰',
      title: 'قیمت مناسب و مقرون‌به‌صرفه',
      desc: 'هاست DirectAdmin با قیمت‌های رقابتی و مناسب، گزینه‌ای ایده‌آل برای کسب‌وکارهای کوچک و متوسط است. شما می‌توانید با هزینه کمتر، از خدمات با کیفیت بالا بهره‌مند شوید.',
    },
    {
      icon: '⚡',
      title: 'عملکرد بالا با سرورهای SSD',
      desc: 'استفاده از دیسک‌های SSD با سرعت بالا برای بارگذاری سریع‌تر وب‌سایت شما و بهبود تجربه کاربری.',
    },
    {
      icon: '🛡️',
      title: 'امنیت پیشرفته و پشتیبانی کامل',
      desc: 'DirectAdmin با امکانات امنیتی پیشرفته و پشتیبانی کامل، از وب‌سایت شما در برابر تهدیدات سایبری محافظت می‌کند.',
    },
  ];

  const faqs = [
    {
      q: 'DirectAdmin چه تفاوتی با cPanel دارد و کدام یک برای من مناسب‌تر است؟',
      a: 'DirectAdmin یک کنترل پنل سبک‌تر و کم‌مصرف‌تر نسبت به cPanel است. این کنترل پنل با منابع کمتر نیز عملکرد عالی دارد و برای سرورهایی با محدودیت منابع مناسب‌تر است. قیمت DirectAdmin نیز معمولاً کمتر از cPanel است. اگر به دنبال کنترل پنلی ساده، سریع و مقرون‌به‌صرفه هستید، DirectAdmin انتخاب مناسبی است. اما اگر به امکانات پیشرفته‌تر و اکوسیستم گسترده‌تر cPanel نیاز دارید، cPanel گزینه بهتری خواهد بود.',
    },
    {
      q: 'آیا هاست DirectAdmin از همه زبان‌های برنامه‌نویسی پشتیبانی می‌کند؟',
      a: 'بله، هاست DirectAdmin مانند cPanel از زبان‌های برنامه‌نویسی محبوب مانند PHP، Python، Node.js و Ruby پشتیبانی می‌کند. همچنین از پایگاه‌های داده MySQL و MariaDB پشتیبانی کامل دارد. شما می‌توانید هر نوع وب‌سایت یا اپلیکیشن وب را روی هاست DirectAdmin اجرا کنید.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>هاست DirectAdmin | خرید هاست دایرکت ادمین با بهترین قیمت | افرسل</h1>
        <p>خرید هاست DirectAdmin با سرورهای SSD، قیمت مناسب و پشتیبانی ۲۴ ساعته. هاست دایرکت ادمین مناسب برای وب‌سایت‌های شخصی، کسب‌وکارهای کوچک و متوسط.</p>
        <meta name="description" content="خرید هاست DirectAdmin با بهترین قیمت از افرسل. هاست دایرکت ادمین با سرورهای SSD، قیمت مناسب، SSL رایگان و پشتیبانی ۲۴/۷." />
      </div>

      <section className="hosting-directadmin-hero">
        <div className="hosting-directadmin-hero-bg"></div>
        <div className="wrap">
          <div className="hosting-directadmin-hero-content">
            <div className="hosting-directadmin-badge">
              <span className="pulse-dot"></span>
              🔧 هاست DirectAdmin
            </div>
            <h1 className="hosting-directadmin-hero-title">
              هاست <em>DirectAdmin</em>
            </h1>
            <p className="hosting-directadmin-hero-desc">
              هاست DirectAdmin با سرورهای SSD، قیمت مناسب و پشتیبانی ۲۴ ساعته.
              کنترل پنل سبک، سریع و کم‌مصرف با امکانات کامل برای مدیریت وب‌سایت شما.
            </p>
            <div className="hosting-directadmin-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">SSD</span>
                <span className="stat-label">دیسک پرسرعت</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hosting-directadmin-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های هاست DirectAdmin</span>
            <h2 className="sec-h">پلن <em>مناسب</em> وب‌سایت خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع هاست DirectAdmin با قیمت‌های رقابتی و منابع کافی برای هر نوع وب‌سایت.</p>
          </div>
          <div className="hosting-directadmin-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`hosting-directadmin-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="hosting-directadmin-popular-badge">پرفروش‌ترین</span>}
                <div className="hosting-directadmin-plan-tier">{plan.tier}</div>
                <div className="hosting-directadmin-plan-price">
                  <span className="hosting-directadmin-plan-num">{plan.price}</span>
                  <span className="hosting-directadmin-plan-unit">{plan.unit}</span>
                </div>
                <div className="hosting-directadmin-plan-specs">
                  <div><span>💾</span> {plan.disk}</div>
                  <div><span>🌐</span> {plan.domains}</div>
                  <div><span>📧</span> {plan.email}</div>
                </div>
                <ul className="hosting-directadmin-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="hosting-directadmin-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-directadmin-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای هاست DirectAdmin</span>
            <h2 className="sec-h">چرا <em>هاست DirectAdmin</em> با افرسل؟</h2>
            <p className="sec-p">هاست DirectAdmin با بهترین امکانات و خدمات برای کسب‌وکارهای کوچک و متوسط.</p>
          </div>
          <div className="hosting-directadmin-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="hosting-directadmin-feature-card">
                <span className="hosting-directadmin-feature-icon">{feature.icon}</span>
                <h3 className="hosting-directadmin-feature-title">{feature.title}</h3>
                <p className="hosting-directadmin-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-directadmin-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="hosting-directadmin-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="hosting-directadmin-faq-item">
                <div className="hosting-directadmin-faq-q">{faq.q}</div>
                <div className="hosting-directadmin-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-directadmin-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              هاست <em>DirectAdmin</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید هاست DirectAdmin، از سرعت بالا، قیمت مناسب و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید هاست</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HostingDirectAdmin;
